export default class CursorSparkle {
    constructor(selector = '#cursor-sparkle') {
        var _a;
        this.container = null;
        this.svgs = null;
        this.isAnimating = false;
        this.animationInterval = null;
        this.handleMouseMove = (e) => {
            if (!this.container)
                return;
            // Use .style directly for better performance than setAttribute
            this.container.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
        };
        this.handleClick = () => {
            if (this.isAnimating || !this.container || !this.svgs)
                return;
            this.startAnimation();
        };
        this.container = document.querySelector(selector);
        this.svgs = ((_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelectorAll('svg')) || null;
        if (!this.container && !this.svgs) {
            return;
        }
        this.bindEvents();
    }
    bindEvents() {
        // Use arrow functions to maintain 'this' context automatically
        document.addEventListener('mousemove', this.handleMouseMove);
        document.addEventListener('click', this.handleClick);
    }
    startAnimation() {
        var _a;
        this.isAnimating = true;
        (_a = this.container) === null || _a === void 0 ? void 0 : _a.classList.add('active');
        let currentIndex = 0;
        const frameRate = 120;
        const totalDuration = 400;
        this.animationInterval = window.setInterval(() => {
            var _a, _b;
            (_a = this.svgs) === null || _a === void 0 ? void 0 : _a.forEach((svg, index) => {
                svg.style.opacity = index === currentIndex ? '1' : '0';
            });
            currentIndex = (currentIndex + 1) % (((_b = this.svgs) === null || _b === void 0 ? void 0 : _b.length) || 1);
        }, frameRate);
        setTimeout(() => this.stopAnimation(), totalDuration);
    }
    stopAnimation() {
        var _a, _b;
        if (this.animationInterval) {
            clearInterval(this.animationInterval);
            this.animationInterval = null;
        }
        (_a = this.svgs) === null || _a === void 0 ? void 0 : _a.forEach(svg => (svg.style.opacity = '0'));
        (_b = this.container) === null || _b === void 0 ? void 0 : _b.classList.remove('active');
        this.isAnimating = false;
    }
    /**
     * Clean up listeners to prevent memory leaks if the component is destroyed
     */
    destroy() {
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('click', this.handleClick);
        this.stopAnimation();
    }
}
